var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pnl-attributes"},_vm._l((_vm.attrs),function(attr){return _c('div',{key:attr.key,staticClass:"attr"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(attr.name))]),_vm._v(" "),_c('span',{class:attr.cls},[_vm._v(_vm._s(attr.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }